<template>
  <svg
    :viewBox="`0 0 ${width} ${height}`"
    class="bar-chart"
    preserveAspectRatio="xMidYMid meet"
  >
    <line
      class="axis"
      :x1="0"
      :y1="baseline"
      :x2="width"
      :y2="baseline"
    />
    <g
      v-for="(bar, i) in bars"
      :key="i"
      class="bar-group"
    >
      <rect
        class="bar"
        :x="bar.x"
        :y="bar.y"
        :width="barWidth"
        :height="bar.height"
        rx="2"
      />
      <text
        v-if="bar.value > 0"
        class="bar-value"
        :x="bar.cx"
        :y="bar.y - 4"
        text-anchor="middle"
      >{{ bar.value }}</text>
      <text
        class="bar-label"
        :x="bar.cx"
        :y="height - 5"
        text-anchor="middle"
      >{{ bar.label }}</text>
      <rect
        v-tippy
        class="bar-hit"
        :content="bar.tooltip"
        :x="bar.slotX"
        :y="0"
        :width="slotWidth"
        :height="baseline"
      />
    </g>
  </svg>
</template>

<script>
const SLOT = 44;
const BAR_WIDTH = 26;
const HEIGHT = 170;
const TOP_PADDING = 20;
const BOTTOM_PADDING = 24;

export default {
  props: {
    // Array of { label: String, value: Number }
    values: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    barWidth: BAR_WIDTH,
    slotWidth: SLOT,
    height: HEIGHT,
  }),
  computed: {
    width() {
      return Math.max(this.values.length, 1) * SLOT;
    },
    baseline() {
      return HEIGHT - BOTTOM_PADDING;
    },
    max() {
      return Math.max(1, ...this.values.map((v) => v.value || 0));
    },
    plotHeight() {
      return HEIGHT - TOP_PADDING - BOTTOM_PADDING;
    },
    bars() {
      return this.values.map((v, i) => {
        const value = v.value || 0;
        const barHeight = (value / this.max) * this.plotHeight;
        const slotX = i * SLOT;
        const x = slotX + ((SLOT - BAR_WIDTH) / 2);

        return {
          value,
          label: v.label,
          tooltip: v.tooltip || `${v.label}: ${value}`,
          slotX,
          x,
          cx: x + (BAR_WIDTH / 2),
          y: this.baseline - barHeight,
          height: barHeight,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-chart {
  display: block;
  width: 100%;
  max-width: 560px;
}

.axis {
  stroke: #eee;
  stroke-width: 1;
}

.bar {
  fill: $blue;
  transition: fill 0.15s ease;
}

.bar-hit {
  fill: transparent;
  cursor: pointer;
}

.bar-group:hover .bar {
  fill: $darkblue;
}

.bar-value {
  fill: $gray;
  font-size: 9px;
}

.bar-label {
  fill: $gray;
  font-size: 9px;
}
</style>
